import {METRIC as CONV_METRIC} from '@stripe-internal/conversations-client';

export const METRIC = {
  ...CONV_METRIC,
};
